import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_0a99b25a from 'nuxt_plugin_plugin_0a99b25a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_43cf6434 from 'nuxt_plugin_sentryserver_43cf6434' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_43d41aa8 from 'nuxt_plugin_sentryclient_43d41aa8' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_c5ff8058 from 'nuxt_plugin_plugin_c5ff8058' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_16327e54 from 'nuxt_plugin_pluginclient_16327e54' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_5aa0325e from 'nuxt_plugin_pluginserver_5aa0325e' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_apollomodule_6da0703c from 'nuxt_plugin_apollomodule_6da0703c' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_6bc11470 from 'nuxt_plugin_axios_6bc11470' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_buefy_2da013c1 from 'nuxt_plugin_buefy_2da013c1' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_filters_2b4f519a from 'nuxt_plugin_filters_2b4f519a' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_gravatar_2beef53c from 'nuxt_plugin_gravatar_2beef53c' // Source: ../plugins/gravatar.js (mode: 'all')
import nuxt_plugin_route_17b85036 from 'nuxt_plugin_route_17b85036' // Source: ../plugins/route.js (mode: 'all')
import nuxt_plugin_tour_ca158e30 from 'nuxt_plugin_tour_ca158e30' // Source: ../plugins/tour.js (mode: 'all')
import nuxt_plugin_validation_49678067 from 'nuxt_plugin_validation_49678067' // Source: ../plugins/validation.js (mode: 'all')
import nuxt_plugin_gtag_1aa4c8e6 from 'nuxt_plugin_gtag_1aa4c8e6' // Source: ../plugins/gtag.js (mode: 'client')
import nuxt_plugin_prefs_b365c286 from 'nuxt_plugin_prefs_b365c286' // Source: ../plugins/prefs.js (mode: 'client')
import nuxt_plugin_attribution_f1e2eea2 from 'nuxt_plugin_attribution_f1e2eea2' // Source: ../plugins/attribution.js (mode: 'all')
import nuxt_plugin_chart_48b5b2cf from 'nuxt_plugin_chart_48b5b2cf' // Source: ../plugins/chart.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Social Media Scheduler","titleTemplate":"%s - Postpone","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"author","content":"Grant McConnaughey"},{"name":"keywords","content":"reddit, post, schedule, delay, queue, content creator, twitter, instagram, tiktok, bluesky"},{"name":"google-site-verification","content":"Xs3_qXPgdc738ak9bOHnSoHFbhSEpzi9u27I-dtuaa0"},{"hid":"description","name":"description","content":"Discover the best social media scheduler. Easily schedule your content across Reddit, Twitter, Instagram, Tiktok, and more and grow your audience."},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#0a6cff"},{"name":"twitter:card","content":"summary"},{"name":"twitter:title","content":"Postpone"},{"name":"twitter:description","content":"Discover the best social media scheduler. Easily schedule your content across Reddit, Twitter, Instagram, Tiktok, and more and grow your audience."},{"name":"twitter:creator","content":"@PostponeSocial"},{"property":"og:url","content":"https:\u002F\u002Fwww.postpone.app"},{"property":"og:title","content":"Postpone"},{"property":"og:type","content":"website"},{"property":"og:description","content":"Discover the best social media scheduler. Easily schedule your content across Reddit, Twitter, Instagram, Tiktok, and more and grow your audience."},{"property":"og:image","content":"https:\u002F\u002Fwww.postpone.app\u002Fimg\u002Fsocial-banner.png"},{"name":"apple-mobile-web-app-title","content":"Postpone"}],"link":[{"rel":"apple-touch-icon","href":"\u002Fimg\u002Ficons\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fimg\u002Ficons\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Fimg\u002Ficons\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Fimg\u002Ficons\u002Ffavicon-16x16.png"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Source+Sans+Pro:wght@400;600;700&display=swap"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Source Sans Pro:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@fortawesome\u002Ffontawesome-free@latest\u002Fcss\u002Fall.min.css"}],"script":[{"src":"https:\u002F\u002Fkit.fontawesome.com\u002Feb51769e81.js","crossorigin":"anonymous","defer":true},{"src":"\u002Fjs\u002Frewardful.js"},{"src":"https:\u002F\u002Fr.wdfl.co\u002Frw.js","async":true,"data-rewardful":"2d1753"},{"src":"\u002Fjs\u002Fhelpcrunch.js"},{"src":"https:\u002F\u002Fembed.launchnotes.io\u002Flatest\u002Fdist\u002Fesm\u002Flaunchnotes-embed.js","type":"module","async":""},{"src":"https:\u002F\u002Fembed.launchnotes.io\u002Flatest\u002Fdist\u002Fesm\u002Flaunchnotes-embed.js","nomodule":"","async":""}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_0a99b25a === 'function') {
    await nuxt_plugin_plugin_0a99b25a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_43cf6434 === 'function') {
    await nuxt_plugin_sentryserver_43cf6434(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_43d41aa8 === 'function') {
    await nuxt_plugin_sentryclient_43d41aa8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_c5ff8058 === 'function') {
    await nuxt_plugin_plugin_c5ff8058(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_16327e54 === 'function') {
    await nuxt_plugin_pluginclient_16327e54(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_5aa0325e === 'function') {
    await nuxt_plugin_pluginserver_5aa0325e(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_6da0703c === 'function') {
    await nuxt_plugin_apollomodule_6da0703c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6bc11470 === 'function') {
    await nuxt_plugin_axios_6bc11470(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_2da013c1 === 'function') {
    await nuxt_plugin_buefy_2da013c1(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2b4f519a === 'function') {
    await nuxt_plugin_filters_2b4f519a(app.context, inject)
  }

  if (typeof nuxt_plugin_gravatar_2beef53c === 'function') {
    await nuxt_plugin_gravatar_2beef53c(app.context, inject)
  }

  if (typeof nuxt_plugin_route_17b85036 === 'function') {
    await nuxt_plugin_route_17b85036(app.context, inject)
  }

  if (typeof nuxt_plugin_tour_ca158e30 === 'function') {
    await nuxt_plugin_tour_ca158e30(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_49678067 === 'function') {
    await nuxt_plugin_validation_49678067(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_1aa4c8e6 === 'function') {
    await nuxt_plugin_gtag_1aa4c8e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_prefs_b365c286 === 'function') {
    await nuxt_plugin_prefs_b365c286(app.context, inject)
  }

  if (typeof nuxt_plugin_attribution_f1e2eea2 === 'function') {
    await nuxt_plugin_attribution_f1e2eea2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chart_48b5b2cf === 'function') {
    await nuxt_plugin_chart_48b5b2cf(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
